import React from "react";

export function Button({ className = "", variant = "default", children, ...props }) {
  const baseStyles = "inline-flex items-center justify-center rounded-2xl text-sm font-medium transition-colors focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50";
  
  const variants = {
    default: "bg-cyan-500 text-white hover:bg-cyan-600 dark:bg-cyan-400 dark:text-slate-950 dark:hover:bg-cyan-300",
    outline: "border border-slate-200 bg-transparent hover:bg-slate-100 dark:border-white/15 dark:hover:bg-white/10 dark:text-white",
    ghost: "hover:bg-slate-100 hover:text-slate-900 dark:text-white dark:hover:bg-white/10 dark:hover:text-white",
  };

  const variantStyles = variants[variant] || variants.default;

  return (
    <button className={`${baseStyles} ${variantStyles} px-4 py-2 ${className}`} {...props}>
      {children}
    </button>
  );
}